export default {
    url: '/detail/:id',
    template: `
        <manage-settings-licences-detail
            licence="vm.licence"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            precondition-courses="vm.preconditionCourses"
        />`,
    resolve: {
        licence (LicenceResource, $stateParams) {
            return LicenceResource.get({ id: $stateParams.id, expand: 'licencePeriods,licenceDrlsWithValue,licencePoints' }).$promise;
        },
        classifiers (ClassifierResource) {
            // we add pageSize 0 because we want all the classifiers
            return ClassifierResource.query({ pageSize: 0 }).$promise;
        },
        preconditionCourses (CourseResource, $stateParams) {
            return CourseResource.query({ preconditionCoursesLicenceId: $stateParams.id, pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (licence, classifiers, preconditionCourses, CLASSIFIER_ENUM) {
        this.licence = licence;
        this.departments = classifiers.filter(classifier => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter(classifier => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter(classifier => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
        this.preconditionCourses = preconditionCourses;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/licences/detail/index.js